import API from "../../../../../global/api";
import moment from "moment";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { handleNoDataVisible, PDFHeader } from "../../../../../global/globalFunctions";
import PaymentReceivedStamp from '../../../../../Images/PaymentReceivedStamp.jpg';
import { isEmpty, sumBy, isUndefined } from "lodash";


export const requestAddPayment = () => {
    return {
        type: "REQUEST_ADD_PAYMENT",
    };
};
export const successAddPayment = (data) => {
    return {
        type: "SUCCESS_ADD_PAYMENT",
        payload: data,
    };
};
export const errorAddPayment = () => {
    return {
        type: "ERROR_ADD_PAYMENT",
    };
};
export const AddPaymentApi = (data, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddPayment());
        API.post(`/booking/cash_receive`, data)
            .then((res) => {
                let getData = res.data;
                dispatch(successAddPayment(getData));
                showSuccessAlert(res.data.message);
            }).catch((error) => {
                dispatch(errorAddPayment());
                showErrorAlert(error.response.data.message || "Something went wrong");
            });
    };
};


export const DeletePayentRequest = () => {
    return {
        type: "DELETE_REQUEST_ISSUANCE",
    };
};
export const DeleteSuccessPayment = (id) => {
    return {
        type: "DELETE_SUCCESS_ISSUANCE",
        id: id,
    };
};
export const DeleteErrorPayment = () => {
    return {
        type: "DELETE_ERROR_ISSUANCE",
    };
};
export const DeletePaymentApi = (id, updateTableQuery) => {
    return (dispatch) => {
        dispatch(DeletePayentRequest());
        API.delete(`/booking/delete_cash_receive/${id}`)
            .then((res) => {
                dispatch(DeleteSuccessPayment(id));
                updateTableQuery()
            }).catch((error) => {
                dispatch(errorAddPayment());
            });
    };
};


export const individualPDF = (data) => {
    return (dispatch) => {
        const unit = "pt";
        const size = "A4";
        const orientation = "p";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Payment Receipt");


        doc.setFontSize(12);
        doc.setFont("Times New Roman", "normal")
        doc.text(`Payment ID: ${data.sequenceNumber}`, 50, 130, 0, 20);
        doc.text(`Customer Name: ${data?.shopId?.shopName}`, 50, 145, 0, 20);
        doc.text(`Customer CNIC: ${data?.shopId?.ownerCnic}`, 50, 160, 0, 20);
        doc.text(`Customer NTN: ${data?.shopId?.NTN}`, 50, 175, 0, 20);
        doc.text(`Payment Date: ${moment(data?.date).format('DD-MM-YYYY')}`, 50, 190, 0, 20);
        doc.text(`Received By: ${data?.userDetails.userName}`, 50, 205, 0, 20);
        doc.addImage(PaymentReceivedStamp, "JPG", 330, 120, 90, 80);


        const paymentHeaders = [[
            "Description",
            "Amount (Rs.)"
        ]];
        const paymentBody = [
            [
                { content: "Payment Amount", styles: { halign: "left" } },
                { content: Number(data.payment || 0).toLocaleString(), styles: { halign: "right" } }
            ],
            [
                { content: "Discount", styles: { halign: "left" } },
                { content: Number(data.discount || 0).toLocaleString(), styles: { halign: "right" } }
            ],
            // [
            //     { content: "Closing Balance", styles: { halign: "left" } },
            //     { content: Number(data.closingBalance || 0).toLocaleString(), styles: { halign: "right" } }
            // ],
            [
                {
                    content: "Discount Reason",
                    styles: { halign: "left" }
                },
                {
                    content: data.discountReason || "-",
                    styles: { halign: "right" }
                }
            ],
            [
                {
                    content: "Net Received",
                    styles: { halign: "left", fontStyle: "bold" }
                },
                {
                    content: Number(data.payment || 0).toLocaleString(),
                    styles: { halign: "right", fontStyle: "bold" }
                }
            ]
        ];
        let paymentTable = {
            startY: 230,
            startX: 50,
            head: paymentHeaders,
            body: paymentBody,
            theme: "grid",
            styles: {
                fontSize: 10,
                cellPadding: 6
            },
            headStyles: {
                fillColor: "#2980ba",
                halign: "center",
                fontStyle: "bold"
            },
            // columnStyles: {
            //     0: { cellWidth: 250 },
            //     1: { cellWidth: 150 }
            // }
        };
        doc.autoTable(paymentTable);


        doc.setProperties({ title: `Payment Receipt` });
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
    };
};


export const requestGetPaymentReport = () => {
    return {
        type: "REQUEST_GET_PAYMENT_REPORT",
    };
};
export const successGetPaymentReport = (data) => {
    return {
        type: "SUCCESS_GET_PAYMENT_REPORT",
        payload: data,
    };
};
export const errorGetPaymentReport = () => {
    return {
        type: "ERROR_GET_PAYMENT_REPORT",
    };
};
export const GetPaymentReportApi = (payload) => {
    return (dispatch) => {
        dispatch(requestGetPaymentReport());
        API.post(`/booking/cash_receive_report`, payload).then((res) => {
            let getData = res.data.data;
            if (isEmpty(getData)) {
                handleNoDataVisible();
            } else {
                const unit = "pt";
                const size = "A4";
                const orientation = "l";
                const doc = new jsPDF(orientation, unit, size);
                PDFHeader(doc, "Payment Report");

                doc.setFont("TimesNewRoman", "Normal");
                doc.setFontSize(12);
                doc.text(`Start Date: ${moment(payload.startDate).format('DD-MM-YYYY')}  -  End Date: ${moment(payload.endDate).format('DD-MM-YYYY')}`, 20, 120)

                doc.setFont("TimesNewRoman", "Normal");
                doc.setFontSize(12);
                doc.text(`DSF Name: ${payload.bookerName || ''}`, 20, 135)

                doc.setFont("TimesNewRoman", "Normal");
                doc.setFontSize(12);
                doc.text(`Area Name: ${payload.areaName || ''}`, 20, 150)

                const headers = [[
                    "Sr",
                    "Area Name",
                    "Shop Name",
                    "DSF",
                    "Date",
                    "Opening Balance",
                    "Amount",
                    "Closing Balance",
                    "Discount",
                ]];
                const data = getData.map((x, i) => [
                    i + 1,
                    x?.areaId?.areaName,
                    x?.shopId?.shopName,
                    x?.bookerId?.userName,
                    moment(x.date).format('DD-MM-YYYY'),
                    x.closingBalance || 0,
                    x.payment,
                    isUndefined(x.closingBalance) ? 0 : Number(x.closingBalance || 0) - Number(x.payment),
                    x.discount,
                ]);
                const totalsRow = [
                    "",
                    { content: "TOTAL", colSpan: 1, styles: { halign: "left", fontStyle: "bold" } },
                    "",
                    "",
                    "",
                    "",
                    { content: sumBy(getData, "payment"), styles: { halign: "left", fontStyle: "bold" } },
                    "",
                    { content: sumBy(getData, "discount"), styles: { halign: "left", fontStyle: "bold" } },
                ];
                data.push(totalsRow);
                let content = {
                    startY: 160,
                    startX: 10,
                    head: headers,
                    body: data,
                    theme: 'grid',
                    styles: {
                        fontSize: 9,
                        lineColor: [0, 0, 0],
                        lineWidth: 0.5,
                        cellPadding: 5
                    },
                    margin: {
                        left: 12,
                        right: 35,
                    },
                    headStyles: {
                        lineWidth: 0.5,
                        lineColor: [0, 0, 0]
                    },
                    bodyStyles: {
                        lineWidth: 0.5,
                        lineColor: [0, 0, 0]
                    }
                };
                doc.autoTable(content);


                doc.setProperties({ title: `Payment Report ${moment().format('YYYY-MM-DD')}` });
                var blob = doc.output("blob");
                window.open(URL.createObjectURL(blob));
            }
            dispatch(successGetPaymentReport(getData));
        }).catch((error) => {
            dispatch(errorGetPaymentReport());
        });
    };
};